export * from './IconStarOliveBranches';
export { default as IconStarOliveBranches } from './IconStarOliveBranches';
